/* v8 ignore next */
import type { ContentCategory } from "../../types/category";
import type {
    Content,
    ContentLabel,
    ContentUser,
    ContentVersion,
} from "../../types/content";

export enum SearchSortAttribute {
    RELEVANCY = "RELEVANCY",
    LAST_MODIFIED_DATE = "LAST_MODIFIED_DATE",
    VIEWS_AND_DOWNLOADS = "VIEWS_AND_DOWNLOADS",
}

export interface GetContentDetailsRequest {
    contentId: string;
}

export enum ComplianceState {
    COMPLIANT = "COMPLIANT",
    UNSUPPORTED_PAGE_SIZE = "UNSUPPORTED_PAGE_SIZE",
    UNSUPPORTED_MEDIA_TYPE = "UNSUPPORTED_MEDIA_TYPE",
    UNSUPPORTED_PAGE_SIZE_AND_MEDIA_TYPE = "UNSUPPORTED_PAGE_SIZE_AND_MEDIA_TYPE",
    UNSUPPORTED_PPTX = "UNSUPPORTED_PPTX",
    UNSUPPORTED_VIEW = "UNSUPPORTED_VIEW",
}

export interface GetContentDetailsResponse {
    content: Content;
    contentUsers: ContentUser[];
    contentLabels: ContentLabel[];
    previousVersions: ContentVersion[];
    downloadUrl: string;
    tinyUrl: string;
}

// SearchContents
export interface SearchContentsRequest {
    contentStatus: "ACTIVE" | "ARCHIVED";
    filters: string[];
    maxResults: number;
    nextPageToken: string | null;
    query: string;
    sortAttribute: SearchSortAttribute;
}

export interface SearchContentsResponse {
    contents: Content[];
    nextPageToken: string;
    numHits: number;
}

export interface GetContentCategoriesRequest {
    categoryIds: string[];
}

export enum ActivityStatus {
    ACTIVE = "ACTIVE",
    INACTIVE = "INACTIVE",
}
export interface GetContentCategoriesResponse {
    contentCategoryNodes: ContentCategory[];
}

export interface GetContentDownloadUrlResponse {
    contentId: string;
    downloadUrl: string;
    version: number;
}
